import { padding, margin } from 'polished'

export const __wrapper = ({ theme, flex = true, unsetMargin }) => ({
	marginRight: '10px',
	marginTop: theme.spaces['20'],
	display: flex ? 'flex' : 'block',
	extend: [
		{
			condition: unsetMargin,
			style: {
				marginRight: '0px',
				marginTop: '0px',
			},
		},
	],
})

export const __slider = ({
	size,
	isEnabled,
	isOn,
	fillColor,
	offColor,
	theme,
}) => ({
	position: 'relative',
	userSelect: 'none',
	width: `${size}px`,
	height: `${Math.floor(0.5 * size)}px`,
	padding: (size / 2 - 3 - Math.floor(size / 2.9)) / 2,
	borderRadius: `${Math.floor(0.5 * size)}px`,
	border: `1.5px solid ${
		offColor && !isOn
			? theme.colors[offColor]
			: fillColor || theme.primary(theme).backgroundColor
	}`,
	boxSizing: 'border-box',
	backgroundColor: `${
		// eslint-disable-next-line
		isEnabled
			? isOn
				? fillColor || theme.primary(theme).backgroundColor
				: theme.colors.white
			: theme.colors.lightGrey4
	}`,
	transition:
		'background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, border-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',

	'> input': {
		zIndex: theme.zIndex.level2,
		cursor: `${isEnabled ? 'pointer' : 'default'}`,
		opacity: '0',
		width: '100%',
		height: `${Math.floor(0.5 * size)}px`,
		margin: '0px',
		position: 'absolute',
		top: '50%',
		transform: 'translateY(-50%)',
	},
})

export const __handle = ({
	size,
	isEnabled,
	isOn,
	fillColor,
	offColor,
	theme,
}) => ({
	transform:
		isEnabled && isOn
			? `translateX(${Math.floor(0.5 * size)}px)`
			: 'translateX(0)',
	width: `${Math.floor(size / 2.9)}px`,
	height: `${Math.floor(size / 2.9)}px`,
	borderRadius: '50%',
	backgroundColor: `${
		// eslint-disable-next-line
		isEnabled
			? // eslint-disable-next-line no-nested-ternary
			  isOn
				? theme.colors.white
				: offColor
				? theme.colors[offColor]
				: fillColor || theme.primary(theme).backgroundColor
			: theme.colors.lightGrey4
	}`,
	transition:
		'transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
})

/* Radio Icon */

export const __label = ({ boldLabel, fontSize, radioXS }) => ({
	display: 'inline',
	fontSize: fontSize || 16,
	marginBottom: radioXS ? '0' : '10',
	marginLeft: '10',
	color: '#333333',
	fontWeight: boldLabel ? 500 : 300,
	cursor: 'pointer',
})

export const __input = ({ theme, checked, radioXS }) => ({
	zIndex: 0,
	border: '1px solid',
	borderColor: theme.primary(theme).backgroundColor,
	verticalAlign: 'middle',
	fontSize: theme.font.size12,
	background: theme.colors.white,
	color: theme.colors.darkGrey4,
	outline: 'none',
	transition: 'border-color 0.2s ease',
	position: 'relative',
	height: 18,
	width: 18,
	...margin(1, 0, 0),
	padding: 0,
	appearance: 'none',
	borderRadius: '50%',
	cursor: 'pointer',
	'&:focus': {
		borderColor: theme.primary(theme).backgroundColor,
		outline: 'none',
	},
	'&::before': {
		content: "''",
		position: 'absolute',
		backgroundColor: checked
			? theme.primary(theme).backgroundColor
			: 'transparent',
		transition: 'all 0.2s ease-out',
		borderRadius: '50%',
		height: checked ? 12 : 3,
		width: checked ? 12 : 3,
		top: checked ? 2 : 5,
		left: checked ? 2 : 5,
	},
	extend: {
		condition: radioXS === true,
		style: {
			height: 14,
			width: 14,
			'&::before': {
				content: "''",
				height: checked ? 8 : 3,
				width: checked ? 8 : 3,
				top: checked ? 2 : 5,
				left: checked ? 2 : 5,
			},
		},
	},
})
export const __radio = ({ theme }) => ({
	cursor: 'pointer',
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'flex-start',
	...padding('20', 0),
	borderBottom: '1px solid #F1F1F1',
	'&:hover input': {
		borderColor: theme.primary(theme).backgroundColor,
	},
})

export const __radioGroup = ({ flex }) => ({
	textAlign: 'left',
	verticalAlign: 'middle',
	display: flex ? 'flex' : 'initial',
	fontSize: 20,
	fontColor: '#333333',
	marginBottom: 30,
})

export const __text = props => {
	const { theme, hasError } = props
	const primary = theme.primary(theme)

	return {
		position: 'absolute',
		bottom: '-1rem',
		left: '0',
		color: hasError ? primary.errorColor : '#999999',
		fontSize: theme.font.size12,
		'> svg': {
			marginRight: '4px',
			marginTop: '-2px',
		},
	}
}
